module.exports = __webpack_public_path__ + "static/img/zhaoshang.9f413cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/zhaoshang.jpg
// module id = nBpD
// module chunks = 1